import { BudgetResetTypeValues } from 'src/components/oneCorp/features/MealCredit/common/formFields/Select/BudgetResetTypeSelect/BudgetResetTypeSelect.utils';
import { MealCreditLength } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';
import { getSingularOrPlural } from 'src/utilities/getSingularOrPlural';
import { MealCreditInfoTextProps } from 'src/components/oneCorp/features/MealCredit/utils/constructMealCreditInfoText.utils';

export function getAvailabilityTextForRefreshUseCases(
  props: Pick<
    MealCreditInfoTextProps,
    | 'budgetResetPeriod'
    | 'isDailyLengthBudget'
    | 'isWeeklyLengthBudget'
    | 'isMonthlyLengthBudget'
    | 'budgetLength'
    | 'budgetResetType'
  >
): string {
  const {
    budgetResetPeriod,
    isDailyLengthBudget,
    isWeeklyLengthBudget,
    isMonthlyLengthBudget,
    budgetLength,
    budgetResetType,
  } = props;
  const refreshText = 'Refreshes every';

  const isCustomDaysLengthBudget =
    MealCreditLength.CUSTOM === budgetLength &&
    budgetResetType === BudgetResetTypeValues.DAYS;

  const isCustomWeeksLengthBudget =
    MealCreditLength.CUSTOM === budgetLength &&
    budgetResetType === BudgetResetTypeValues.WEEKS;

  const isCustomMonthsLengthBudget =
    MealCreditLength.CUSTOM === budgetLength &&
    budgetResetType === BudgetResetTypeValues.MONTHS;

  if (isDailyLengthBudget) {
    return `${refreshText} day`;
  }

  if (isCustomDaysLengthBudget) {
    return `${refreshText} ${budgetResetPeriod} ${getSingularOrPlural(
      budgetResetPeriod,
      'day'
    )}`;
  }

  if (isCustomWeeksLengthBudget) {
    return `${refreshText} ${budgetResetPeriod} ${getSingularOrPlural(
      budgetResetPeriod,
      'week'
    )}`;
  }

  if (isWeeklyLengthBudget) {
    return `${refreshText} week`;
  }

  if (isMonthlyLengthBudget) {
    return `${refreshText} month`;
  }

  if (isCustomMonthsLengthBudget) {
    return `${refreshText} ${budgetResetPeriod} ${getSingularOrPlural(
      budgetResetPeriod,
      'month'
    )}`;
  }

  return '';
}
